import { useState } from "react";
import { paymentCancel } from "../api/payment";

export const useCancelModal = () => {
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    orderId: "",
    accountNumber: "",
    accountHolder: "",
    bankName: "",
    cancelReason: "",
    userRef: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const resetModalState = () => {
    setIsCancelModalOpen(false);
    setFormData({
      orderId: "",
      accountNumber: "",
      accountHolder: "",
      bankName: "",
      cancelReason: "",
      userRef: "",
    });
    setErrors({});
    setIsSubmitting(false);
  };

  const openCancelModal = (order_id, cancel_reason) => {
    updateFormData("orderId", order_id);
    updateFormData("cancelReason", cancel_reason);
    setIsCancelModalOpen(true);
  };

  const closeCancelModal = () => {
    resetModalState();
  };

  const updateFormData = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.accountNumber.trim()) {
      newErrors.accountNumber = "계좌번호를 입력해주세요.";
    } else if (!/^\d+$/.test(formData.accountNumber)) {
      newErrors.accountNumber = "계좌번호는 숫자만 입력해주세요.";
    }

    if (!formData.accountHolder.trim()) {
      newErrors.accountHolder = "예금주명을 입력해주세요.";
    }

    if (!formData.bankName.trim()) {
      newErrors.bankName = "은행명을 선택해주세요.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const submitCancelRequest = async () => {
    if (!validateForm()) return false;

    setIsSubmitting(true);

    try {
      const res = await paymentCancel(
        formData.orderId,
        formData.bankName,
        formData.accountHolder,
        formData.accountNumber,
        formData.cancelReason,
        formData.userRef
      );
      console.log(22, res);
      if (res.success === true) {
        alert("취소 신청이 완료되었습니다.");
        resetModalState();
        return true;
      } else {
        alert(res.error.message);
        return false;
      }
    } catch (error) {
      console.error("Cancel request error:", error);
      alert("취소 신청 중 오류가 발생했습니다. 다시 시도해주세요.");
      setIsSubmitting(false);
      return false;
    }
  };

  return {
    isCancelModalOpen,
    formData,
    errors,
    isSubmitting,
    closeCancelModal,
    updateFormData,
    submitCancelRequest,

    openCancelModal,
    resetModalState,
    validateForm,

    setIsCancelModalOpen,
    setFormData,
    setErrors,
    setIsSubmitting,
  };
};
